import React, { ChangeEvent, ComponentPropsWithoutRef } from 'react';
import clsx from '../clsx';

import styles from './Switch.module.scss';

interface SwitchProps extends ComponentPropsWithoutRef<'span'> {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Switch = ({
  name,
  checked,
  disabled,
  className,
  onChange,
  ...otherProps
}: SwitchProps) => {
  return (
    <span
      className={clsx(styles.switch, className, {
        [styles.disabled]: disabled,
        [styles.active]: checked
      })}
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={0}
      {...otherProps}
    >
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />

      <div className={styles.switchBase}>
        <div className={styles.track} />
        <div className={styles.thumb} />
      </div>
    </span>
  );
};

export default Switch;
